import { Capacitor } from "@capacitor/core";

// Inside the phone app every page lives at capacitor://localhost (iOS) or
// https://localhost (Android): fine for moving around the app, a dead link
// anywhere else (founder, 1.5.1 #16 — "Share DJ profile" sent exactly that).
const PUBLIC_ORIGIN = "https://requesta.app";

/**
 * A link that still works once it leaves this screen: shared, copied for the
 * laptop, or handed to Stripe. The app always hands out requesta.app; the
 * website keeps its own address (localhost in development, a preview deploy).
 * Moving around inside the app doesn't need this. No path = this page.
 */
export function publicUrl(
  path: string = window.location.pathname + window.location.search + window.location.hash
): string {
  return `${Capacitor.isNativePlatform() ? PUBLIC_ORIGIN : window.location.origin}${path}`;
}
